import React from "react";

const MainHeaderButtonsWrapper = ({ children }) => {
  return (
    <div className="flex items-center gap-2 ml-auto">
      {children}
    </div>
  );
};

export default MainHeaderButtonsWrapper;
